import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class SalesService {
    Create = async (manualInvoice) =>
        await HttpClient.Post(`/api/sales`, manualInvoice);

    GetSales = async (req) => {
        const queryString = utils.GetQueryStringsFromObject(req)
        return await HttpClient.Get(`/api/sales/search/sales?${queryString}`);
    }

    SaleCancelation = async (orderId) =>
    await HttpClient.Post(`/api/sales/${orderId}/cancelation`);

    GetAllConcepts = async () =>
        await HttpClient.Get(`/api/sales/AllConcepts`);

    CreateSalesConcepts = async (req) =>
        await HttpClient.Post(`/api/sales/CreateConcepts`, req);
}

export default new SalesService();